/**
 * Anmeldung. Nur Google — der Passwort-Zweig aus crm-web ist hier weg, weil
 * `login()` dort ausschliesslich eine Fehlermeldung erzeugt ("Please use
 * Google login"): ein Formular, das nie etwas anmelden kann.
 */

import { useSearchParams } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';

export function LoginPage() {
  const { loginWithGoogle, error, isLoading } = useAuth();
  const [params] = useSearchParams();

  // `?ziel=` setzt die ProtectedRoute: der Pfad INNERHALB dieser Anwendung,
  // auf den nach der Anmeldung zurueckgesprungen wird. Wichtig fuer /scan —
  // wer den Startbildschirm-Knopf antippt und nicht angemeldet ist, soll
  // danach auf der Kamera landen und nicht auf der Startseite.
  const ziel = params.get('ziel') || '/';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <Card className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-primary-500 text-white text-2xl font-bold mb-4">
            E
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Elbklar Buchhaltung</h1>
          <p className="text-gray-600 mt-2">
            Melde dich an, um Belege, Zahlungen und Bank zu bearbeiten.
          </p>
        </div>

        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
            {error}
          </div>
        )}

        <Button
          variant="outline"
          className="w-full"
          onClick={() => loginWithGoogle(ziel)}
          disabled={isLoading}
        >
          <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="currentColor"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="currentColor"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="currentColor"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          Mit Google anmelden
        </Button>
      </Card>
    </div>
  );
}
